export const MRT_CONTEXT_BASEPATH = '/mobify/mrt'
export const MRT_API_BASEPATH = MRT_CONTEXT_BASEPATH + '/api'
export const MAX_CACHE_AGE = 60 * 15 // 15 min
export const MAX_CACHE_AGE_SEARCH = 60 * 3 // 3 min
